import { DRAWER_TYPES } from "../types";

export interface IDrawer {
  open: boolean;
  width: any;
  appBarSelectedItem: string;
  subMenuItemsStore: any;
  subMenuVisibility: any;
  subMenuSelectedItem: any;
}

const initialState: IDrawer = {
  open: true,
  width: 180,
  appBarSelectedItem: "Home",
  subMenuItemsStore: null,
  // subMenuVisibility:localStorage.getItem("subMenuVisible") === "true",
  subMenuVisibility: true,
  subMenuSelectedItem: localStorage.getItem("selectedSubItem") || null,
};

export const drawerReducer = (
  state: IDrawer = initialState,
  action: any,
): IDrawer => {
  switch (action.type) {
    case DRAWER_TYPES.DRAWER_OPEN_SET_SELECTED:
      return {
        ...state,
        open: action.payload.open,
      };
    case DRAWER_TYPES.DRAWER_CLOSE_SELECTED:
      return {
        ...state,
        open: initialState.open,
      };
    case DRAWER_TYPES.DRAWER_WIDTH_SET_SELECTED:
      return {
        ...state,
        width: action.payload.width,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.APP_BAR_ITEM_SET_SELECTED:
      return {
        ...state,
        appBarSelectedItem: action.payload.appBarSelectedItem,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.SUB_MENU_ITEMS_SET_SELECTED:
      return {
        ...state,
        subMenuItemsStore: action.payload.subMenuItemsStore,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.SUB_MENU_ITEMS_CLEAR_SELECTED:
      return {
        ...state,
        subMenuItemsStore: initialState.subMenuItemsStore,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.SUB_MENU_VISIBILITY_SET_SELECTED:
      return {
        ...state,
        subMenuVisibility: action.payload.subMenuVisibility,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.SUB_MENU_VISIBILITY_CLEAR_SELECTED:
      return {
        ...state,
        subMenuVisibility: initialState.subMenuVisibility,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.SUB_MENU_ITEM_SET_SELECTED:
      return {
        ...state,
        subMenuSelectedItem: action.payload.subMenuSelectedItem,
        // open: action.payload.open,
      };
    case DRAWER_TYPES.SUB_MENU_ITEM_CLEAR_SELECTED:
      return {
        ...state,
        subMenuSelectedItem: initialState.subMenuSelectedItem,
        // open: action.payload.open,
      };
    default:
      return state;
  }
};
